// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","161":"92d5a5d9","618":"846dd1fe"}[chunkId] + ".css";
};